import React, { useEffect } from "react";
import { createSvgIcon } from "./fieldManager"; // You'll need to extract this function

const DragDropHandler = ({
  formData,
  droppedFields,
  setDroppedFields,
  isDragging,
  setIsDragging,
}) => {
  // Handle drag start for fields
  const handleDragStart = (e, fieldType, user = null) => {
    const dragData = {
      tabType: fieldType,
      user: user || { id: 1, first_name: "Default", last_name: "User" },
      width: 100,
      height: 36,
      position: { x: 0, y: 0 },
      isSelected: false,
      color: "#e6eaff",
      borderColor: "#ff9999",
      textColor: "#2868d7",
      borderWidth: 1,
      borderStyle: "solid",
    };

    e.dataTransfer?.setData("text/plain", JSON.stringify(dragData));

    // Create transparent drag image
    const dragImage = document.createElement("div");
    dragImage.textContent = `${fieldType}`;
    dragImage.style.backgroundColor = "transparent";
    dragImage.style.color = "transparent";
    dragImage.style.padding = "10px";
    dragImage.style.borderRadius = "4px";
    dragImage.style.position = "absolute";
    dragImage.style.top = "-1000px";
    document.body.appendChild(dragImage);

    e.dataTransfer.setDragImage(dragImage, 0, 0);

    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);

    // Create floating element
    const floatingElement = document.createElement("div");
    floatingElement.id = "floating-drag-element";
    floatingElement.style.position = "fixed";
    floatingElement.style.backgroundColor = "#e6eaff";
    floatingElement.style.color = "#2868d7";
    floatingElement.style.border = "1px solid #2868d7";
    floatingElement.style.borderRadius = "2px";
    floatingElement.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
    floatingElement.style.padding = "5px";
    floatingElement.style.display = "flex";
    floatingElement.style.flexDirection = "column";
    floatingElement.style.alignItems = "center";
    floatingElement.style.justifyContent = "center";
    floatingElement.style.zIndex = "9999";
    floatingElement.style.pointerEvents = "none";
    floatingElement.style.boxSizing = "border-box";
    floatingElement.style.gap = "2px";
    floatingElement.style.overflow = "hidden";

    const iconElement = document.createElement("div");
    iconElement.style.display = "flex";
    iconElement.style.alignItems = "center";
    iconElement.style.justifyContent = "center";
    iconElement.style.height = "16px";
    iconElement.style.width = "20px";
    iconElement.innerHTML = createSvgIcon(fieldType);
    floatingElement.appendChild(iconElement);

    const textElement = document.createElement("div");
    textElement.textContent = fieldType;
    textElement.style.fontSize = "10px";
    textElement.style.lineHeight = "12px";
    textElement.style.textAlign = "center";
    textElement.style.width = "100%";
    textElement.style.display = "flex";
    textElement.style.alignItems = "center";
    textElement.style.justifyContent = "center";
    floatingElement.appendChild(textElement);

    document.body.appendChild(floatingElement);
    floatingElement.style.display = "none";

    setIsDragging(true);
  };

  // Handle drag over to show/hide floating element
  useEffect(() => {
    const handleDragOver = (e) => {
      const floatingElement = document.getElementById("floating-drag-element");
      if (!floatingElement) return;

      let isOverDocument = false;

      for (let i = 0; i < (formData?.forms_data?.total_pages || 0); i++) {
        const canvas = document.getElementById(`myCanvas${i}`);
        const fieldWrap = document.getElementById(`fieldWrap${i}`);

        if (canvas) {
          const canvasRect = canvas.getBoundingClientRect();
          if (
            e.clientX >= canvasRect.left &&
            e.clientX <= canvasRect.right &&
            e.clientY >= canvasRect.top &&
            e.clientY <= canvasRect.bottom
          ) {
            isOverDocument = true;
            break;
          }
        }

        if (fieldWrap) {
          const fieldWrapRect = fieldWrap.getBoundingClientRect();
          if (
            e.clientX >= fieldWrapRect.left &&
            e.clientX <= fieldWrapRect.right &&
            e.clientY >= fieldWrapRect.top &&
            e.clientY <= fieldWrapRect.bottom
          ) {
            isOverDocument = true;
            break;
          }
        }
      }

      floatingElement.style.display = isOverDocument ? "block" : "none";

      if (isOverDocument) {
        floatingElement.style.left = `${e.clientX}px`;
        floatingElement.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener("dragover", handleDragOver);

    return () => {
      document.removeEventListener("dragover", handleDragOver);
    };
  }, [formData?.forms_data?.total_pages]);

  return null; // This component doesn't render anything visible
};

export default DragDropHandler;
